import * as modalTypes from '../types/modalTypes';
import Basic from './Basic';

export default {
  [modalTypes.BASIC]: Basic,
};
